<!-- Quick stats boxes -->
<div class="row">
    <div class="col-lg-3">

        <!-- Members online -->
        <div class="panel bg-light-400">
            <div class="panel-body">
                <div class="heading-elements">
                    <ul class="icons-list">
                        <li>
                            <a data-action="reload"></a>
                        </li>
                    </ul>
                </div>

                <h3 class="no-margin">{{ekubAnalytics?.total_members}}</h3>
                <strong>Total Members</strong>
                <div class="text-size-small">{{ekubAnalytics?.active_members}} active members</div>
            </div>

            <div class="container-fluid">
                <div id="members-online"></div>
            </div>
        </div>
        <!-- /members online -->

    </div>

    <div class="col-lg-3">

        <!-- Current server load -->
        <div class="panel bg-light-400">
            <div class="panel-body">
                <div class="heading-elements">
                    <ul class="icons-list">
                        <li>
                            <a data-action="reload"></a>
                        </li>
                    </ul>
                </div>

                <h3 class="no-margin">{{ekubAnalytics?.total_sales?.count}}</h3>
                <strong>Total Sales</strong>
                <div class=" text-size-small">Pending sales - {{ekubAnalytics?.pending_sales?.count}} -
                    {{ekubAnalytics?.pending_sales?.value|number:'1.2-2'}} ETB </div>
            </div>

            <div id="server-load"></div>
        </div>
        <!-- /current server load -->

    </div>

    <div class="col-lg-3">

        <!-- Today's revenue -->
        <div class="panel bg-light-400">
            <div class="panel-body">
                <div class="heading-elements">
                    <ul class="icons-list">
                        <li>
                            <a data-action="reload"></a>
                        </li>
                    </ul>
                </div>

                <h3 class="no-margin">{{ekubAnalytics?.awards_granted?.count}}</h3>
                <strong>Awards Granted</strong>
                <div class="text-size-small">Estimated value - {{ekubAnalytics?.awards_granted?.value|number:'1.2-2'}}
                    ETB</div>
            </div>

            <div id="today-revenue"></div>
        </div>
        <!-- /today's revenue -->

    </div>


    <div class="col-lg-3">

        <!-- Today's revenue -->
        <div class="panel bg-light-700">
            <div class="panel-body">
                <div class="heading-elements">
                    <ul class="icons-list">
                        <li>
                            <a data-action="reload"></a>
                        </li>
                    </ul>
                </div>

                <h3 class="no-margin">{{ekubAnalytics?.awards_pending?.count|number:'1.0-2'}}</h3>
                <strong>Awards Pending</strong>
                <div class="text-size-small">Estimated value - {{ekubAnalytics?.awards_granted?.value|number:'1.2-2'}}
                    ETB</div>
            </div>

            <div id="today-revenue"></div>
        </div>
        <!-- /today's revenue -->

    </div>

</div>
<!-- /quick stats boxes -->

<div class="row">

    <div class="col-md-8">

        <!-- Marketing campaigns -->
        <div class="panel panel-flat">


            <div class="tabbable">
                <ul class="nav nav-tabs nav-tabs-highlight">
                    <li class="active"><a href="#analytics-tab" data-toggle="tab"> <i
                                class="icon-brain position-left"></i>Ekub Analytics</a></li>
                    <li><a href="#transactions-tab" data-toggle="tab"> <i
                                class="icon-stats-bars3 position-left"></i>Transactions Statistics</a></li>
                </ul>

                <div class="tab-content">
                    <div class="tab-pane active" id="analytics-tab">

                        <!--  <div class="row">
            
                            <div class="col-md-4">
            
                                <div class="sidebar-category">
                                    <div class="category-title">
                                        <span>Completeness stats</span>
                                        <ul class="icons-list">
                                            <li><a href="#" data-action="collapse"></a></li>
                                        </ul>
                                    </div>
            
                                    <div class="category-content">
                                        <ul class="progress-list">
                                            <li>
                                                <label>Highest priority <span>80%</span></label>
                                                <div class="progress progress-xxs">
                                                    <div class="progress-bar progress-bar-danger" style="width: 80%">
                                                        <span class="sr-only">80% Complete</span>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <label>High priority <span>70%</span></label>
                                                <div class="progress progress-xxs">
                                                    <div class="progress-bar progress-bar-info" style="width: 70%">
                                                        <span class="sr-only">70% Complete</span>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <label>Normal priority <span>50%</span></label>
                                                <div class="progress progress-xxs">
                                                    <div class="progress-bar progress-bar-primary" style="width: 50%">
                                                        <span class="sr-only">50% Complete</span>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <label>Low prioruty <span>60%</span></label>
                                                <div class="progress progress-xxs">
                                                    <div class="progress-bar progress-bar-success" style="width: 60%">
                                                        <span class="sr-only">60% Complete</span>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
            
                        </div> -->


                        <div class="panel-heading">
                            <h6 class="panel-title">Ekub Members</h6>
                            <div class="heading-elements">
                                <ul class="icons-list">
                                    <li><a data-action="collapse"></a></li>
                                    <li><a data-action="reload"></a></li>
                                    <li><a data-action="close"></a></li>
                                </ul>
                            </div>
                        </div>


                        <div class="table-responsive">

                            <table class="table table-striped text-nowrap table-customers">
                                <thead>
                                    <tr>
                                        <th>Member</th>
                                        <th>Email</th>
                                        <th>Code</th>
                                        <th>Joined</th>
                                        <th>Balance</th>
                                        <th>Rounds</th>
                                        <th>Actions</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let member of ekubAnalytics?.members">
                                        <td>
                                            <div class="media">
                                                <!-- <a href="user_pages_profile_tabbed.html" class="media-left">
                                                    <img src="../../../../global_assets/images/placeholders/placeholder.jpg"
                                                        width="40" height="40" class="img-circle img-md" alt="">
                                                </a> -->
                                                <span class="media-left">
                                                    <img *ngIf="!member?.member?.data?.avatar"
                                                        src="assets/img/userm.png" width="40" height="40"
                                                        class="img-circle img-md" alt="">
                                                    <a *ngIf="member?.member?.data?.avatar" href="javascript:void(0)"
                                                        data-toggle="modal" data-target="#profileImModal">
                                                        <img [src]="baseUrl+'assets/'+member?.member?.data?.avatar+'/render'"
                                                            width="40" height="40" class="img-circle img-md" alt="">
                                                    </a>
                                                </span>
                                                <div class="media-body media-middle">
                                                    <a href="user_pages_profile_tabbed.html" class="text-semibold">
                                                        {{member?.member?.data?.username}}</a>
                                                    <div class="text-muted text-size-small">
                                                        Latest Deposit: {{ (member?.latest_deposit)?(member?.latest_deposit | date:short):'N/A'}}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>{{member?.member?.data?.email}}</td>
                                        <td>{{member?.member?.data?.pivot?.code}}</td>
                                        <td>{{member?.member?.data?.pivot?.created_at | date:short}}</td>
                                        <td>
                                            <ul class="list list-unstyled no-margin">
                                                <li class="no-margin">
                                                    <i
                                                        class="icon-checkmark3 text-size-base text-success position-left"></i>
                                                    Due:
                                                    <a href="#">{{member?.member_balance_due}} ETB</a>
                                                </li>
                                                <li class="no-margin">
                                                    <i class="text-size-base position-left"
                                                        [ngClass]="{'text-success-400 icon-checkmark3':(member?.member_balance >= member?.member_balance_due),'text-warning icon-cross2 ':(member?.member_balance < member?.member_balance_due)}"></i>
                                                    Balance:
                                                    <a href="#">{{member?.member_balance}} ETB</a>
                                                </li>

                                                
                                            </ul>
                                        </td>
                                        <td>
                                            <ul class="list list-unstyled no-margin">
                                                <li class="no-margin">
                                                    <i
                                                        class="icon-checkmark3 text-size-base text-success position-left"></i>
                                                    Current:
                                                    <a href="#">{{ekubAnalytics?.current_round}}</a>
                                                </li>

                                                <li class="no-margin">
                                                    <i class="text-size-base position-left"
                                                        [ngClass]="{'text-success-400 icon-checkmark3':(member?.member_payments_count >= ekubAnalytics?.current_round),'text-warning icon-cross2 ':(member?.member_payments_count < ekubAnalytics?.current_round)}"></i>
                                                    Member:
                                                    <a href="#">{{member?.member_payments_count}}</a>
                                                </li>
                                            </ul>
                                        </td>
                                        <td class="text-right">
                                            <ul class="icons-list">
                                                <li class="dropdown">
                                                    <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                                                        <i class="icon-menu7"></i>
                                                        <span class="caret"></span>
                                                    </a>

                                                    <ul class="dropdown-menu dropdown-menu-right">
                                                        <li><a href="#"><i class="icon-file-pdf"></i>
                                                                Invoices</a>
                                                        </li>
                                                        <li><a href="#"><i class="icon-cube2"></i> Shipping
                                                                details</a></li>
                                                        <li><a href="#"><i class="icon-credit-card"></i> Billing
                                                                details</a>
                                                        </li>
                                                        <li class="divider"></li>
                                                        <li><a href="#"><i class="icon-warning2"></i> Report
                                                                problem</a>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </td>
                                        <td class="no-padding-left"></td>
                                    </tr>

                                </tbody>
                            </table>

                            <div class="text-center">

                                <pagination-controls id="ekubMemberss">
                                </pagination-controls>

                                <br>
                            </div>

                        </div>










                    </div>

                    <div class="tab-pane has-padding" id="transactions-tab">



                        <fusioncharts [chartConfig]=chartConfig2 [dataSource]=dataSource2>
                        </fusioncharts>



                    </div>

                </div>
            </div>





        </div>
        <!-- /marketing campaigns -->

    </div>

    <div class="col-md-4">

        <div class="panel panel-body overflow-hidden">

            <fusioncharts [chartConfig]=chartConfig [dataSource]='pieDataSource'>
            </fusioncharts>
            <h4 class="custom-title">Top Lagging Members</h4>
            <hr>
            <div class="table-responsive">
                <table class="table table-striped text-nowrap table-customers">
                    <thead>
                        <tr>
                            <th>Ekub</th>
                            <th>Members</th>
                            <th>Amount</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let lEkub of ekubAnalytics?.lagging">
                            <td>
                                <div class="media">

                                    <div class="media-body media-middle">
                                        <a href="user_pages_profile_tabbed.html"
                                            class="text-semibold">{{lEkub?.member?.data?.username}}</a>
                                        <div class="text-muted text-size-small">
                                            Latest deposit: Oct 21 2022
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <ul class="list list-unstyled no-margin">
                                    <li class="no-margin">
                                        <i class="icon-checkmark3 text-size-base text-success position-left"></i>

                                        <a href="#"> {{lEkub?.current_round}} {{ekub?.category?.data?.interval_name}}</a>
                                    </li>

                                    <li class="no-margin">
                                        <i class="text-size-base position-left"
                                        [ngClass]="{'text-success-400 icon-checkmark3':(lEkub?.member_payments_count >=lEkub?.current_round),'text-warning icon-cross2':(lEkub?.member_payments_count < lEkub?.current_round)}"></i>
                                        <a href="#"> {{lEkub?.member_payments_count}} {{ekub?.category?.data?.interval_name}}</a>
                                    </li>
                                </ul>
                            </td>
                            <td class="text-left">
                                <ul class="list list-unstyled no-margin">
                                    <li class="no-margin">
                                        <i class="icon-checkmark3 text-size-base text-success position-left"
                                        ></i>
                                        <a href="#"> {{lEkub?.member_balance_due}} ETB</a>
                                    </li>

                                    <li class="no-margin">
                                        <i class="text-size-base position-left"
                                        [ngClass]="{'text-success-400 icon-checkmark3':(lEkub?.member_balance >=lEkub?.member_balance_due),'text-warning icon-cross2':(lEkub?.member_balance < lEkub?.member_balance_due)}"></i>
                                        <a href="#"> {{lEkub?.member_balance}} ETB</a>
                                    </li>
                                </ul>
                            </td>
                            <td class="no-padding-left"></td>
                        </tr>

                    </tbody>
                </table>
            </div>

        </div>

    </div>
</div>